exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-body p[data-v-4ddcd7c9]:last-child{margin-bottom:0}.loading[data-v-4ddcd7c9]{line-height:1;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ddcd7c9","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/common/outlet-filter.vue
// module id = 6FWq
// module chunks = 99